import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
import webSocket from '@/sockets/socket';
class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  getDevices = 'number-device';
  update = 'update';
  nearest = 'nearest';
  detail = 'detail';

  async getDetailRequest(id) {
    let request = {
      url: [this.getAPIUrl(), 'edit', id].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  async getDetailRequestCompanyCode(companyCode) {
    let request = {
      url: [this.getAPIUrl(), this.detail, companyCode].join('/'),
    };
    var res = httpClient.getAsync(request);
    return res;
  }

  async insertRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: model,
    };
    var res = await httpClient.postAsync(request);
    return res;
  }
  async updateRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.update].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async getDevicesOfDomain(domain, key) {
    let request = {
      url: [this.getAPIUrl(), this.getDevices, domain].join('/'),
      data: JSON.stringify({ packageUpgradeKey: key }),
    };
    var res = httpClient.postAsync(request);
    return res;
  }

  async deletelRequest(model) {
    let request = {
      url: [this.getAPIUrl()].join('/'),
      data: JSON.stringify(model),
    };
    var res = httpClient.deleteAsync(request);

    return res;
  }

  async nearestRequest() {
    let request = {
      url: [this.getAPIUrl(), this.nearest].join('/'),
    };
    var res = httpClient.getAsync(request, false);
    return res;
  }
}

export default new RequestAPI();
